import type { AlchemyType } from '@/domain/genetics/types';

export interface CombatProjectile {
  id: string;
  owner: 'player' | 'enemy';
  x: number;
  y: number;
  vx: number;
  vy: number;
  radius: number;
  damage: number;
  type: AlchemyType;
  expiresAt: number;
}

export interface SpawnProjectileInput {
  id: string;
  owner: CombatProjectile['owner'];
  x: number;
  y: number;
  dirX: number;
  dirY: number;
  speed: number;
  radius: number;
  damage: number;
  type: AlchemyType;
  nowMs: number;
  lifetimeMs: number;
}

export function spawnProjectile(input: SpawnProjectileInput): CombatProjectile {
  const magnitude = Math.hypot(input.dirX, input.dirY);
  const dirX = magnitude < 0.01 ? 1 : input.dirX / magnitude;
  const dirY = magnitude < 0.01 ? 0 : input.dirY / magnitude;
  return {
    id: input.id,
    owner: input.owner,
    x: input.x,
    y: input.y,
    vx: dirX * input.speed,
    vy: dirY * input.speed,
    radius: input.radius,
    damage: input.damage,
    type: input.type,
    expiresAt: input.nowMs + input.lifetimeMs,
  };
}

export function advanceProjectile(projectile: CombatProjectile, dtMs: number): CombatProjectile {
  const dtSeconds = Math.max(0, dtMs) / 1_000;
  return {
    ...projectile,
    x: projectile.x + projectile.vx * dtSeconds,
    y: projectile.y + projectile.vy * dtSeconds,
  };
}

export function projectileHitsCircle(
  projectile: Pick<CombatProjectile, 'x' | 'y' | 'radius'>,
  target: { x: number; y: number; radius: number },
): boolean {
  return Math.hypot(projectile.x - target.x, projectile.y - target.y) <= projectile.radius + target.radius;
}
